import { useCallback } from 'react';

import { useLocale } from '@tanium/react-locale-context';

import { defaultTickFormatter } from '../formatters/defaultTickFormatter';
import { NumberCoercible } from '../utils/NumberCoercible';
import { NumberFormatterType } from '../utils/NumberFormatterType';

/**
 * Hook that returns a locale aware tick formatter.
 */
export const useLocalizedTickFormatter = (): NumberFormatterType => {
  const locale = useLocale();
  return useCallback((value: NumberCoercible) => defaultTickFormatter(value, locale), [locale]);
};
